import clsx from 'clsx'
import { type ReactElement, type HTMLAttributes } from 'react'

import type { PageSwoosh } from '@constants/enums/swoosh'

import { getBackgroundAndColorScheme } from '@components/page-core/section/color-scheme'
import { getSectionAnchorId } from '@components/page-core/section/page-section'
import type { SectionStructure } from '@components/page-core/section/page-section'
import { SectionHeader } from '@components/section-header/section-header'
import { getSwooshStyle } from '@components/swoosh'
import { Section } from '@components/ui-core/section/section'

import sectionStyles from '../section/page-section.module.scss'

import styles from './group.module.scss'

export interface PageSectionGroupProps extends SectionStructure, HTMLAttributes<HTMLElement> {
  internalName: string
  sectionGroupSwoosh?: PageSwoosh
}

export function GroupPageSection({
  className,
  children,
  background,
  heading,
  sysStructure,
  sectionGroupSwoosh,
}: PageSectionGroupProps): ReactElement {
  const anchorId = getSectionAnchorId(sysStructure)
  const { colorScheme, background: semanticBackground } = getBackgroundAndColorScheme(background)

  const { className: swooshClassName, backgroundImage } = getSwooshStyle(sectionGroupSwoosh)

  return (
    <div
      data-is-section-group="true"
      data-color-scheme={colorScheme}
      data-background-color={semanticBackground}
      id={anchorId}
      className={clsx('contain-images', className)}
    >
      <div className={clsx(swooshClassName, styles.container)} style={{ backgroundImage }}>
        {heading ? (
          <Section className={sectionStyles.pageSection}>
            <SectionHeader heading={heading} />
          </Section>
        ) : null}
        {children}
      </div>
    </div>
  )
}
